import React, { useState } from 'react';
import './Animals.css';

// Import images for fruits
import DogImage from './images/Dog.jpg';
import CatImage from './images/Cat.jpg';
import ElephantImage from './images/Elephant.jpg';
import LionImage from './images/Lion.jpg';
import TigerImage from './images/Tiger.jpg';
import BearImage from './images/Bear1.jpg';
import GiraffeImage from './images/Giraffe.jpg';
import MonkeyImage from './images/Monkey.jpg';
import RabbitImage from './images/Rabbit.jpg';
import HorseImage from './images/Horse2.jpg';

import CowImage from './images/Cow.jpg';
import BuffaloImage from './images/Buffalo.jpg';
import DeerImage from './images/Deer.jpg';
import FoxImage from './images/Fox.jpg';
import WolfImage from './images/Wolf.jpg';
import PigImage from './images/Pig.jpg';

const fruits = [
  { name: 'Dog', image: DogImage },
  { name: 'Cat', image: CatImage },
  { name: 'Elephant', image: ElephantImage },
  { name: 'Lion', image: LionImage },
  { name: 'Tiger', image: TigerImage },
  { name: 'Bear', image: BearImage },
  { name: 'Giraffe', image: GiraffeImage },
  { name: 'Monkey', image: MonkeyImage },
  { name: 'Rabbit', image: RabbitImage },
  { name: 'Horse', image: HorseImage },

  { name: 'Cow', image: CowImage },
  { name: 'Buffalo', image: BuffaloImage },
  { name: 'Deer', image: DeerImage },
  { name: 'Fox', image: FoxImage },
  { name: 'Wolf', image: WolfImage },
  { name: 'Pig', image: PigImage }
];

const Animals = () => {
  const [selectedFruit, setSelectedFruit] = useState(null);
  const [quizFruit, setQuizFruit] = useState(null);
  const [quizAnswer, setQuizAnswer] = useState('');
  const [quizResult, setQuizResult] = useState('');

  const speakFruit = (fruitName) => {
    const utterance = new SpeechSynthesisUtterance(fruitName);
    window.speechSynthesis.speak(utterance);
  };

  const handleFruitClick = (fruit) => {
    setSelectedFruit(fruit);
    speakFruit(fruit.name);
  };

  const startQuiz = () => {
    const randomFruit = fruits[Math.floor(Math.random() * fruits.length)];
    setQuizFruit(randomFruit);
    setQuizAnswer('');
    setQuizResult('');
  };

  const submitQuiz = () => {
    if (quizAnswer.toLowerCase() === quizFruit.name.toLowerCase()) {
      setQuizResult('Correct!');
    } else {
      setQuizResult(`Wrong! The correct Animal was ${quizFruit.name}`);
    }
  };

  const clearQuiz = () => {
    setQuizFruit(null);
    setQuizAnswer('');
    setQuizResult('');
  };

  const nextQuiz = () => {
    startQuiz();
  };

  return (
    <div className="AppFruits">
      <h1>Learn Animals</h1>
      <div className="fruits">
        {fruits.map((fruit) => (
          <div
            key={fruit.name}
            className="fruit-box"
            onClick={() => handleFruitClick(fruit)}
          >
            <img src={fruit.image} alt={fruit.name} className="fruit-image" />
            <p>{fruit.name}</p>
          </div>
        ))}
      </div>
      {selectedFruit && <div className="selected-fruit">You selected: {selectedFruit.name}</div>}
      <div className="quiz-section">
        <h2>Quiz Mode</h2>
        {quizFruit ? (
          <div>
            <p>Which Animal is this?</p>
            <img src={quizFruit.image} alt="Quiz Animal" className="quiz-image" />
            <input
              type="text"
              value={quizAnswer}
              onChange={(e) => setQuizAnswer(e.target.value)}
              placeholder="Enter Animal name"
            />
            <button onClick={submitQuiz}>Submit</button>
            <button onClick={nextQuiz}>Next Animal</button>
            <button onClick={clearQuiz}>Clear</button>
            {quizResult && <p>{quizResult}</p>}
          </div>
        ) : (
          <button onClick={startQuiz}>Start Quiz</button>
        )}
      </div>
    </div>
  );
};

export default Animals;



